<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="ips modal"
        tabindex="-1"
        role="dialog"
        :aria-labelledby="modalTitleId"
        :aria-hidden="isHidden"
        @keydown.esc="close"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <slot>
              <header class="modal-header">
                <slot name="header"><h1 :id="modalTitleId">Heading Text</h1></slot>
                <ips-icon icon="ico-close" @click="close"></ips-icon>
              </header>
              <section class="modal-body modal-alert">
                <slot name="alerts"></slot>
              </section>
              <section class="modal-body">
                <slot name="body"></slot>
              </section>
              <footer class="modal-footer justify-content-between">
                <div>
                  <slot name="footer_left"></slot>
                </div>
                <div>
                  <slot name="footer_right"></slot>
                </div>
              </footer>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import IpsIcon from '@ipscape/ips-icon';

export default {
  name: 'IpsModal',
  components: { IpsIcon },
  props: {
    modalTitleId: {
      type: String,
      name: 'Modal title id',
      description: 'Adds an id to the modal title',
      required: false,
      default: 'modalTitleId',
    },
    isHidden: {
      type: Boolean,
      name: 'Hidden',
      description: 'Used for the aria-hidden attribute',
      required: false,
      default: true,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'IpsModal';
</style>
